<template>
  <div
    class="expandable"
    :class="{ 'expandable--open': isOpen }"
    :style="elementStyle"
    v-on="$listeners"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'Expandable',

  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },

    transitionTime: {
      type: Number,
      default: On.TransitionTimes.normal,
    },
  },

  data() {
    return {
      height: 'auto',
      heightAnimationTimeout: null,
    }
  },

  computed: {
    elementStyle() {
      return {
        height: this.height,
        transitionDuration: `${this.transitionTime}ms`,
      }
    },
  },

  watch: {
    async isOpen() {
      this.$emit('height-change', this.$el.scrollHeight * (this.isOpen ? 1 : -1))
      this.updateHeight()

      if (this.heightAnimationTimeout) clearTimeout(this.heightAnimationTimeout)
      this.heightAnimationTimeout = setTimeout(this.afterHeightChange, this.transitionTime)
    },
  },

  mounted() {
    this.updateHeight()
  },

  updated() {
    // This is to account for i-frames or other content that is loaded later
    this.updateHeight()
  },

  methods: {
    updateHeight() {
      if (!this.isOpen) return (this.height = '0px')
      this.height = this.$el?.scrollHeight ? `${this.$el.scrollHeight}px` : 'auto'
    },

    afterHeightChange() {
      this.$emit('height-change-end')
    },
  },
}
</script>

<style lang="scss" scoped>
.expandable {
  position: relative;
  overflow: hidden;
  transition-property: height;
  transition-timing-function: ease-out;
  will-change: height;
}
</style>
